export enum DutyLineFlag {
  CREDIT = 'CREDIT',
  FIXED_BUH = 'FIXED_BUH',
  BLOCK_SWAP = 'BLOCK_SWAP',
  APPROVED = 'APPROVED',
  STATUS_CALCULATED = 'STATUS_CALCULATED',
  BUH_BLOCKED = 'BUH_BLOCKED',
  BUH_DEBLOCK = 'BUH_DEBLOCK',
  HOURS_NOMINAL = 'HOURS_NOMINAL',
  STATUS_BLOCKED = 'STATUS_BLOCKED',
  DHT_CHANGED = 'DHT_CHANGED',
  PERIODS_CHANGED = 'PERIODS_CHANGED',
  ANY_CHANGED = 'ANY_CHANGED',
  INVOICE_BLOCKED = 'INVOICE_BLOCKED',
  INVOICE_UNBLOCK = 'INVOICE_UNBLOCK',
  SUBSIDY_BLOCKED = 'SUBSIDY_BLOCKED',
  STATUS_AGENCY = 'STATUS_AGENCY',
  STATUS_DEPARTMENT = 'STATUS_DEPARTMENT',
  STATUS_EMPLOYEE = 'STATUS_EMPLOYEE',
  STATUS_FIAT_MANAGER = 'STATUS_FIAT_MANAGER',
  INTENT_REALIZATION = 'INTENT_REALIZATION',
  SAL_SYSTEM_BLOCKED = 'SAL_SYSTEM_BLOCKED',
  REJECTED = 'REJECTED',
  MATCHED_BY_FLEX = 'MATCHED_BY_FLEX'
}

export enum EmployeeType {
  OWN = 'OWN',
  PREF = 'PREF',
  FLEX = 'FLEX',
  BORROWING = 'BORROWING'
}

export enum EmployeeCostCenterType {
  OWN = 'OWN',
  SHARED = 'SHARED',
  PREFERENCE1 = 'PREFERENCE1',
  PREFERENCE2 = 'PREFERENCE2',
  EXTERNAL = 'EXTERNAL',
  FLEX = 'FLEX',
  DEPLOYABLE_AS_FLEX_PREFERENCE1 = 'DEPLOYABLE_AS_FLEX_PREFERENCE1',
  DEPLOYABLE_AS_FLEX = 'DEPLOYABLE_AS_FLEX'
}

export enum SelfMatchAction {
  NONE = 'NONE',
  SUBSCRIBE = 'SUBSCRIBE',
  CONNECT = 'CONNECT'
}

export enum StatusSvc {
  APPROVED = 'a',
  PRE_REALIZED = 'p',
  REALIZED = 'r',
  INVOICED = 'i'
}

export enum AggregateOn {
  MONTH = 'MONTH',
  WEEK = 'WEEK'
}

export enum Units {
  DAY = 'DAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
  QUARTER = 'QUARTER',
  YEAR = 'YEAR'
}

export enum ScenarioAdditionalCapacityType {
  FLEX = 'FLEX',
  LOAN = 'LOAN',
  BORROW = 'BORROW'
}

export enum FunctionColor {
  DEFAULT = '#939393',
  UNKNOWN = '#cccbcb',
  WORK_DEMAND = '#0d233a',
  BASE_PLAN = '#0094bf',
  FORMATION = '#ffd100',
  ROSTER = '#00b1aa',
  DIRECT_CLIENT_CARE = '#00b1aa',
  INDIRECT_CLIENT_CARE = '#0094bf',
  ORGANISATION = '#ed7422'
}

export enum PlanUnitType {
  FLEX = 'flex',
  COST_CENTER = 'cc',
  AGENCY = 'agn',
  REGIONAL_POOL = 'rgp'
}
